import { ComponentProps } from 'react';
import { useTranslation } from '@frontend/i18n';
import { ThreadSendingAreaComponents } from '@frontend/thread-sending-area';
import { theme } from '@frontend/theme';
import { Button, Modal } from '@frontend/design-system';
import { MultiSendView } from './multi-send-view';

type MultiSendViewModalContentsProps = ComponentProps<typeof MultiSendView> & {
  onClose: () => void;
  onBack?: () => void;
  disableSend?: boolean;
} & Pick<ComponentProps<typeof ThreadSendingAreaComponents.SendButton>, 'onSend' | 'onSchedule' | 'hidePausable'>;

export const MultiSendViewModalContents = ({
  onClose,
  onSend,
  onSchedule,
  onBack,
  hidePausable,
  disableSend,
  ...rest
}: MultiSendViewModalContentsProps) => {
  const { t } = useTranslation('integrated-messaging');

  return (
    <>
      <Modal.Header onClose={onClose} css={{ paddingBottom: theme.spacing(1) }}>
        {t('Share in Message')}
      </Modal.Header>
      <Modal.Body>
        <MultiSendView
          css={{
            borderRadius: theme.borderRadius.small,
            border: `1px solid ${theme.colors.neutral20}`,
          }}
          {...rest}
          onSubmit={disableSend ? undefined : rest.onSubmit}
        />
      </Modal.Body>
      <Modal.Footer
        css={{
          display: 'flex',
          gap: theme.spacing(1),
          alignItems: 'center',
          justifyContent: onBack ? 'space-between' : 'end',
          padding: theme.spacing(2, 3, 0),
        }}
      >
        {!!onBack && (
          <Button variant='tertiary' onClick={onBack}>
            {t('Back')}
          </Button>
        )}
        <div
          css={{
            display: 'flex',
            gap: theme.spacing(1),
            alignItems: 'center',
            justifyContent: 'end',
          }}
        >
          <ThreadSendingAreaComponents.SendButton
            canSchedule
            labelText={t('Send Now')}
            buttonType='button'
            onSend={onSend}
            onSchedule={onSchedule}
            variant='primary'
            disabled={disableSend}
            hidePausable={hidePausable}
          />
        </div>
      </Modal.Footer>
    </>
  );
};
